import React from 'react';
import FAQ from 'ui/src/components/FAQ';
import faqStructuredData from 'utilities/src/faqStructuredData';
import twMerge from 'utilities/src/twMerge';

type Props = {
  title: string;
  questions: { question: string; answer: string }[];
  className?: string;
};

/**
 * The shared FAQ accordion plus the post's FAQPage JSON-LD.
 */
export default function ArticleFaq({ title, questions, className }: Props) {
  return (
    <>
      <script
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqStructuredData({ questions })) }}
      />
      <FAQ
        title={title}
        questions={questions}
        className={twMerge('border-site-neutrals-100 gap-12 border-t pb-8 pt-16', className)}
        titleClassName="site-display-s text-site-neutrals-700 font-bold"
        questionsClassName="[&>li:last-child]:mb-0 [&>li:last-child]:border-b-0"
      />
    </>
  );
}
